import type { Client } from '@core/generated/gql-types';
import {
  createFieldFilterConfig,
  type FilterConfig,
} from '@/components/filters';

export type ClientFilterConfig = FilterConfig<Client>;

const FIELD_FILTER_CONFIG = [
  createFieldFilterConfig<Client>('status', 'Status', 'status'),
  createFieldFilterConfig<Client>('suburb', 'Suburb', 'address.suburb'),
  createFieldFilterConfig<Client>('state', 'State', 'address.state'),
  createFieldFilterConfig<Client>('postcode', 'Postcode', 'address.postcode'),
  createFieldFilterConfig<Client>('chargeType', 'Charge Type', 'chargeType'),
];

export const createClientFilterConfig = (): ClientFilterConfig[] => [
  ...FIELD_FILTER_CONFIG,
];

export const CLIENT_FILTER_KEYS = FIELD_FILTER_CONFIG.map((f) => f.key);
